import {rpcCall} from "../../util/rpc/rpcCalls"
import {apiExceptions, ValidationErrors} from "./constants"
import {getFeaturesChangesMessage} from '../../features/utils'
import {Feature} from '../../features/constants'
import {BASE_PATH} from 'constants'
import messageResource from '../../messageResource'

export function addNewWorkflowStatus(status) {
    return rpcCall("WorkflowStatusesService.addWorkflowStatus", [status.name, status.colorId, status.type], _handleError)
}

export function updateWorkflowStatus(status) {
    return rpcCall("WorkflowStatusesService.editWorkflowStatus", [status.id, status.name, status.colorId], _handleError)
}

export function deleteWorkflowStatus(statusId) {
    return rpcCall("WorkflowStatusesService.deleteWorkflowStatus", [statusId], _handleError)
}

export function updateWorkflowStatusPosition({id, newPosition}) {
    return rpcCall("WorkflowStatusesService.moveWorkflowStatus", [id, newPosition], _handleError)
}

export function getPageData() {
    return rpcCall("WorkflowStatusesService.getWorkflowStatuses", [], _handleError)
}

function _handleError(error){
    if (error.errorThrown.exception === apiExceptions.FEATURE_DISABLED_EXCEPTION) {
        const msg = getFeaturesChangesMessage({
            [Feature.TWS]: false
        }).concat(messageResource.getMessage('common.interface_will_reloaded'))

        alert(msg)
        window.location.href = BASE_PATH
    }

    let data = {}
    if (error.errorThrown['workflowStatusesInfo']) {
        data = JSON.parse(error.errorThrown['workflowStatusesInfo'])
    }
    error.handleOnException(apiExceptions.DUPLICATE_NAME_EXCEPTION, {error: ValidationErrors.DUPLICATE_NAME_ERROR, data})
    error.handleOnException(apiExceptions.STATUS_DELETED_EXCEPTION, {error: ValidationErrors.STATUS_DELETED, data})
    error.handleOnException(apiExceptions.STATUS_IN_USE_EXCEPTION, {error: ValidationErrors.STATUS_IN_USE, data})
    error.handleOnException(apiExceptions.STATUS_IS_LAST_EXCEPTION, {error: ValidationErrors.STATUS_IS_LAST, data})
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/apiCalls.js